<template>
  <div>
    <modal :show="true">
      <template slot="header">
        <h5 class="modal-title" id="label">{{ $t('title') }}</h5>
      </template>

      {{ newPlayerNickname }} {{ $t('text') }}
      <br />
      <br />
      <br />

      <template slot="footer">
        <base-button type="primary" @click="closeDialog()">{{$t('ok')}}</base-button>
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  props: ["newPlayerNickname"],
  data: function() {
    return {

    };
  },
  mounted() {
    this.$bus.$on("close", () => {
      this.$bus.$emit('close-new-player-dialog');
    });
  },
  beforeDestroy() {
    this.$bus.$off("close");
  },   
  computed: {
  },
  methods: {
    closeDialog() {
      this.$store.dispatch(
        "log",
        "closeDialog()"
      );

      this.$store.dispatch(
        "log",
        "Emitting close-new-player-dialog event."
      );
      this.$bus.$emit('close-new-player-dialog');
    }
  }
};
</script>

<i18n>
{
  "en": {
    "title": "New Player",
    "text": "just joined the simulation. You can guide them to answer the questions and click 'next' until they catch up with the rest of the group.",
    "ok": "OK"
  },
  "fi": {
    "title": "Uusi pelaaja",
    "text": "liittyi juuri mukaan simulaatioon. Voit ohjeistaa häntä vastaamaan kysymyksiin ja klikkaamaan 'eteenpäin' kunnes hän saavuttaa muun ryhmän.",
    "ok": "OK"
  },
  "sv": {
    "title": "Ny spelare",
    "text": "gick precis med i simuleringen. Du kan instruera dem att svara på frågorna och klicka på 'nästa' tills de kommer ikapp resten av gruppen.",
    "ok": "OK"
  },
  "de": {
    "title": "Neuer Spieler",
    "text": "hat sich gerade der Simulation angeschlossen. Sie können ihn anleiten, die Fragen zu beantworten und auf 'weiter' zu klicken, bis er die Gruppe eingeholt hat.",
    "ok": "OK"
  },
  "ko": {
    "title": "신규 플레이어",
    "text": "시뮬레이션에 참여했습니다. 질문에 답변하고 '다음'을 클릭하여 다른 참여자들을 따라잡을 수 있도록 안내할 수 있습니다.",
    "ok": "네"
  }
}
</i18n>
